// Connects page builder "Talq chat" blocks to an inline Talq widget.
// Loads the Talq library at most once and reuses window.Talq when a site's custom code already loaded it.
const TALQ_SRC = 'https://unpkg.com/@calq/talq-widget@0.3.0/dist/widget.js';

let talqPromise = null;

function loadTalq() {
    if (talqPromise) {
        return talqPromise;
    }

    talqPromise = new Promise((resolve, reject) => {
        if (window.Talq && typeof window.Talq.createInlineWidget === 'function') {
            resolve(window.Talq);
            return;
        }

        let script = document.querySelector('script[src*="@calq/talq-widget"]');
        if (!script) {
            script = document.createElement('script');
            script.src = TALQ_SRC;
            script.async = true;
            document.head.appendChild(script);
        }

        script.addEventListener('load', () => {
            window.Talq ? resolve(window.Talq) : reject(new Error('Talq library loaded without window.Talq'));
        });
        script.addEventListener('error', () => reject(new Error('Talq library failed to load')));
    });

    return talqPromise;
}

function initBlock(Talq, block) {
    const widget = Talq.createInlineWidget({
        widgetId: block.dataset.widgetId,
        element: block.querySelector('[data-talq-chat]'),
    });
    const buttons = block.querySelectorAll('button[data-question]');

    buttons.forEach((button) => {
        button.addEventListener('click', () => widget.sendMessage(button.dataset.question));
    });

    const enable = () => buttons.forEach((button) => { button.disabled = false; });

    // ready never settles when the chat fails to start; the buttons then stay disabled on purpose.
    if (widget.ready && typeof widget.ready.then === 'function') {
        widget.ready.then(enable, () => {});
    } else {
        enable();
    }
}

function startBlock(block) {
    loadTalq()
        .then((Talq) => initBlock(Talq, block))
        .catch((error) => console.warn('[talq-block]', error));
}

function initTalqBlocks() {
    const blocks = document.querySelectorAll('[data-talq-block]:not([data-talq-initialized])');
    if (!blocks.length) {
        return;
    }

    blocks.forEach((block) => { block.dataset.talqInitialized = 'true'; });

    if (!('IntersectionObserver' in window)) {
        blocks.forEach(startBlock);
        return;
    }

    // Load the library and start the chat iframe only once a block nears the viewport.
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                startBlock(entry.target);
            }
        });
    }, { rootMargin: '400px 0px' });

    blocks.forEach((block) => observer.observe(block));
}

// Wait for the parser so scripts from custom code at the end of <body> have defined window.Talq.
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTalqBlocks);
} else {
    initTalqBlocks();
}
